import React from 'react';

export const PanelWrapper = props => (
  <div className="bg-white shadow-sm p-4 mb-5 bg-white rounded" >{props.children}</div>
);
